import { Box, Typography } from '@mui/material';
import React from 'react';
import { useRecordContext, useTranslate } from 'react-admin';
import { useFormContext, useWatch } from 'react-hook-form';
import PropTypes from 'prop-types';
import ImportFileInput from '@/components/global/inputs/ImportFileInput.jsx';
import { CustomButton } from '@/components/global/buttons/CustomButton.jsx';
import DeleteIcon from '@/assets/icons/delete-icon.svg?react';

const GroupDeviceFileInput = ({ sx }) => {
    const translate = useTranslate();
    const record = useRecordContext();
    const { setValue } = useFormContext();
    const deleteFile = useWatch({ name: 'deleteFile' });

    const handleRemoveFile = () => {
        setValue('deleteFile', true, { shouldDirty: true });
    };

    return (
        <Box
            sx={{
                ...sx,
                '& .RaLabeled-label': { display: 'none' },
            }}
        >
            <ImportFileInput source='file' accept='.zip' placeholderText={translate('resources.deviceGroup.fields.importConfig')} />

            {record?.fileChecksum && (
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '20px', margin: '-10px 0px 20px 0px' }}>
                    {!deleteFile && (
                        <Typography variant='body2' color='text.secondary' sx={{ fontWeight: 500 }}>
                            {translate('resources.deviceGroup.labels.dataZip')}
                        </Typography>
                    )}
                    <CustomButton label='common.removeFile' color='secondary' type='button' onClick={handleRemoveFile} disabled={!!deleteFile}>
                        <DeleteIcon />
                    </CustomButton>
                </Box>
            )}
        </Box>
    );
};

GroupDeviceFileInput.propTypes = {
    sx: PropTypes.object,
};

export default GroupDeviceFileInput;
